import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Images } from '@constants/images';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { User } from '@models/user';
import { MenuFacade } from "@redux/facades/menu.facade";
import { LanguageFacade } from "@redux/facades/language.facade";
import { take } from "rxjs/operators";
import { RouteInfo } from "@models/my-menu";
import {Module} from "@models/module";
import {CModules} from "@constants/c-modules";
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {

  public images = Images;
  public menuItems: any[] = [];
  public menuLarge = false;
  public menuPermanent = false;
  public routes: RouteInfo[] = [];

  // @ts-ignore
  public unsubscribeMenu: Subscription;
  public userEmail: string;
  public userRole: string;
  public user: User | null = null;
  private CModules = CModules;
  private modules: Module[] = [];
  public arrowBottom = Images.arrow_next;
  public language: string = 'es';

  constructor(
    private element: ElementRef,
    private router: Router,
    public authService: AuthService,
    public menuFacade: MenuFacade,
    public languageFacade: LanguageFacade
  ) {
    const self = this;
    self.languageFacade.languageState$.pipe(take(1)).subscribe(
      ok => {
        self.language = ok.selected;
      }
    );
    const base = '/admin/' + this.language;
    this.routes = [];
    const modules: any = JSON.parse(<string>sessionStorage.getItem('modules'));
    this.modules = modules;
    const adminModuleID : number = this.CModules.find(e => e.moduleName == "Admin CMS All")?.moduleID ?? 0;
    if (this.modules !== null && this.modules.find(e => e.moduloID == adminModuleID)) {
      this.routes = [
        { path: base + '/home', title: 'menu.home.title',  icon: Images.icon_home, class: '', rol: [1], open: false, submenu: [] },
        { path: base + '/settings', title: 'menu.settings.title',  icon: Images.icon_settings, class: '', rol: [1], open: false, submenu:
            [
              { path: base + '/settings/document-type', title: 'menu.settings.document-type' },
              { path: base + '/settings/hiring-company', title: 'menu.settings.hiring-company' },
              { path: base + '/settings/rol-group', title: 'menu.settings.rol-group' },
              { path: base + '/settings/avatar', title: 'menu.settings.avatar' },
              { path: base + '/settings/department', title: 'menu.settings.department' },
              { path: base + '/settings/work-schedule-type', title: 'menu.settings.work-schedule-type' },
              { path: base + '/settings/location', title: 'menu.settings.location' },
              { path: base + '/settings/tenant', title: 'menu.settings.tenant' },
            ]
        }
      ]
    } else {
      this.routes.push({ path: base + '/employee', title: 'menu.employee.title',  icon: Images.icon_group, class: '', rol: [1], open: false, submenu: [] });
      this.routes.push({ path: base + '/work-schedule', title: 'menu.work-schedule.title',  icon: Images.pending_actions, class: '', rol: [1], open: false, submenu: [] });
      this.routes.push({ path: base + '/check-in-out', title: 'menu.check-in-out.title',  icon: Images.fact_check, class: '', rol: [1], open: false, submenu: [] });
      this.routes.push({ path: base + '/questionnaires', title: 'menu.questionaires.title',  icon: Images.icon_forms, class: '', rol: [1], open: false, submenu: [] });
      this.routes.push({ path: base + '/notifications', title: 'menu.notifications.title',  icon: Images.icon_notification, class: '', rol: [1], open: false, submenu: [] });
    }

    self.unsubscribeMenu = self.menuFacade.menuState$.subscribe(
      ok => {
        self.menuLarge = ok.open;
        self.menuPermanent = ok.permanent;
        $('.sidebar').removeClass(!self.menuLarge ? 'menu-large' : 'menu-short');
        $('.sidebar').addClass(self.menuLarge ? 'menu-large' : 'menu-short');
        $('.main-panel').removeClass(!self.menuLarge ? 'menu-large' : 'menu-short');
        $('.main-panel').addClass(self.menuLarge ? 'menu-large' : 'menu-short');
      }
    );
    this.userEmail = sessionStorage.getItem('email') || '';
    this.userRole = sessionStorage.getItem('role') || '0';
  }

  // tslint:disable-next-line:typedef
  ngOnInit() {
    this.menuItems = this.routes; // ROUTES.filter(menuItem => menuItem.rol.includes(Number(this.userRole)));
  }

  // tslint:disable-next-line:typedef
  ngOnDestroy() {
    const self = this;
    self.unsubscribeMenu.unsubscribe();
  }

  public isMobileMenu = () => {
    return $(window).width() <= 991;
  }

  public openSubmenu = (menuItem: RouteInfo) => {
    this.menuItems.map((value) => {
      if (value.path === menuItem.path) {
        menuItem.open = !menuItem.open;
      } else {
        value.open = false;
      }
    });
  }

  public changePermanent = (permanent: boolean) => {
    this.menuFacade.setPermanent(permanent);
  }

  public closeMenu = () => {
    this.menuFacade.setOpen(false);
  }

  public logout = () => {
    this.authService.logout();
    this.router.navigate(['/auth']);
  }
}
